export default "__VITE_ASSET__beea13a7__"